import { render, staticRenderFns } from "./attendants.vue?vue&type=template&id=1e6daf0f&"
import script from "./attendants.vue?vue&type=script&lang=js&"
export * from "./attendants.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports